import get from 'lodash.get';
import { constants } from '@yola/subscription-manager-js';

const {
  hostingPackageFeatureNames: { AI_LOCALIZATION },
} = constants;

const aiLocalizationLimit = ({ targetPackage }) => ({
  available: get(targetPackage, ['features', AI_LOCALIZATION], false),
});

export default aiLocalizationLimit;
